var data = {
	"body": "<g fill=\"none\"><path d=\"M12.937 4.052a.75.75 0 0 0-1.373-.604l-5.5 12.5a.75.75 0 1 0 1.372.604l5.5-12.5z\" fill=\"currentColor\"/><path d=\"M14.293 13.845a.75.75 0 0 1-.137-1.052L16.303 10l-2.148-2.793a.75.75 0 0 1 1.188-.914l2.5 3.25a.75.75 0 0 1 0 .915l-2.5 3.25a.75.75 0 0 1-1.051.137z\" fill=\"currentColor\"/><path d=\"M5.707 6.156a.75.75 0 0 1 .137 1.052L3.696 10l2.148 2.793a.75.75 0 1 1-1.188.915l-2.5-3.25a.75.75 0 0 1 0-.915l2.5-3.25a.75.75 0 0 1 1.051-.137z\" fill=\"currentColor\"/></g>",
	"width": 20,
	"height": 20
};
export default data;
